import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import * as React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import MuiButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

interface Props {
  actions: ButtonProps[];
  fullWidth?: boolean;
}

const ButtonGroup = ({ actions, fullWidth = false }: Props) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    if (actions[index]?.onClick) {
      actions[index].onClick(event as unknown as React.MouseEvent<HTMLLIElement, MouseEvent>);
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <MuiButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="Button group with a nested menu"
      >
        <Button {...actions[0]} fullWidth={fullWidth} />
        <Button
          color={actions[0]?.color ?? 'primary'}
          size={actions[0]?.size ?? 'small'}
          onClick={handleToggle}
        >
          <HugeiconsIcon icon={ArrowDown01Icon} />
        </Button>
      </MuiButtonGroup>
      <Popper
        sx={{ zIndex: 1200 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {actions.map((a, i) => (
                    i !== 0 ? (
                      <MenuItem
                        key={`action-${i}`}
                        disabled={a.disabled}
                        onClick={(event) => handleMenuItemClick(event, i)}
                      >
                        {a.children}
                      </MenuItem>
                    ) : null
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}

export default ButtonGroup;
